<template>
    <li>
        <a v-for="(locale, index) in locales" :key="index" class="btn text-white nav-link my-auto text-uppercase text-white p-1" href="#"
           @click.prevent="setLocale(locale)"
        ><img :src="asset('images/' + locale + '.png')" :alt="locale"></a>
    </li>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            locales: ['de', 'en'],
        }
    },
    methods: {
        setLocale(language) {
            this.$store.dispatch('locale/changeLocale', language)
                .then(() => {
                    this.$i18n.locale = language;
                }).catch((error => {
                    console.log(error);
            }));
        },

    }
}
</script>

<style>
    .language-switcher-dropdown {
        min-width: 90px;
        right: 0;
        left: unset;
    }
</style>
